<template>
  <!-- 
    画面: 割引一覧
    用途: 一般ユーザーが自分の割引一覧(現在有効のみ)を参照する
   -->
  <div>
    <CRow>
      <CCol lg="12">

        <!-- #region 会員割引一覧 -->
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員割引一覧</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <DiscountListTable />
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
        <!-- #endregion 会員割引一覧 -->

      </CCol>
    </CRow>
  </div>
</template>

<script>
import DiscountListTable from "./components/DiscountListTable.vue";

export default {
  name: "DiscountList",

  components: {
    DiscountListTable,
  },

  data() {
    return {
    };
  },

  created() {
  },

  methods: {},
  
};
</script>

<style lang="scss">
.nav-tabs {
  margin-bottom: -1px;
  .nav-link {
    border: 1px solid #cccccc;
    color: #4b5e80;
    &.active {
      background: #cccccc;
      border: 1px solid #cccccc;
      color: #454579;
      font-weight: bold;
    }
  }
}
</style>
